import React from 'react';
// template components
import BulletedList from '@nmx/template/dist/componentLibrary/components/BulletedList';
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
// icons
import CaratRight from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/utility/CaratRight';
// styles
import { LinkStyled } from './styles';

export default () => {
  return (
    <SectionContainer
      id='business-services-planning-and-guidance'
      backgroundVariant='lightB'
      themeType='lightTheme'>
      <Row align='center'>
        <Col medium={6}>
          <Typography
            component='h2'
            align='center'
            nextElement='typography'>
            Planning and guidance
          </Typography>
        </Col>
      </Row>
      <Row align='center'>
        <Col medium={8}>
          <Typography nextElement='link'>
            We&#39;ve got 164&#43; years of guiding people just like you to their financial potential. Learn how we offer solutions designed for you, for your employees and for your key employees. Let us help you:
          </Typography>
          <BulletedList
            bulletType='filledCircle'
            bulletedListData={[
              {
                bulletText: (
                  <LinkStyled
                    id='business-services-business-risk-management-link'
                    variant='primaryDeemphasize'
                    endAdornment={CaratRight}
                    endAdornmentStylesReset
                    linkUrl='/financial-planning/business-risk-management/'>
                    Assess and manage risk
                  </LinkStyled>
                ),
              },
              {
                bulletText: (
                  <LinkStyled
                    id='business-services-employee-benefits-planning-link'
                    variant='primaryDeemphasize'
                    endAdornment={CaratRight}
                    endAdornmentStylesReset
                    linkUrl='/financial-planning/business-services/employee-benefits-planning/'>
                    Review and select employee benefits
                  </LinkStyled>
                ),
              },
              {
                bulletText: (
                  <LinkStyled
                    id='business-services-non-qualified-retirement-plan-link'
                    variant='primaryDeemphasize'
                    endAdornment={CaratRight}
                    endAdornmentStylesReset
                    linkUrl='/financial-planning/retirement-planning/non-qualified-retirement-plan/'
                    ariaLabel='Consider the benefits of a non&#45;qualified retirement plan.'>
                    Consider other benefits
                  </LinkStyled>
                ),
              },
              {
                bulletText: (
                  <LinkStyled
                    id='business-services-business-succession-planning-link'
                    variant='primaryDeemphasize'
                    endAdornment={CaratRight}
                    endAdornmentStylesReset
                    linkUrl='/financial-planning/business-services/business-succession-planning/'>
                    Plan your legacy
                  </LinkStyled>
                ),
              },
              {
                bulletText: (
                  <Link
                    id='business-services-personal-financial-planning-link'
                    variant='primaryDeemphasize'
                    endAdornment={CaratRight}
                    endAdornmentStylesReset
                    linkUrl='/financial-planning/business-services/personal-financial-planning/'>
                    Make a financial plan
                  </Link>
                ),
              },
            ]}
          />
        </Col>
      </Row>
    </SectionContainer>
  );
};
